/**
 * Front page hero: open/close video modal from [data-hero-video-popup]
 */
(function() {
	'use strict';

	var modal = document.getElementById('hero-video-popup');
	if (!modal) {
		return;
	}

	var video = modal.querySelector('[data-hero-video]');
	var videoWrap = modal.querySelector('.hero-video-popup__video-wrap');
	var lastTrigger = null;
	var scrollbarCompensation = 0;

	function getScrollbarWidth() {
		if (typeof window.innerWidth === 'number') {
			return window.innerWidth - document.documentElement.clientWidth;
		}
		return 0;
	}

	function lockScroll() {
		scrollbarCompensation = getScrollbarWidth();
		document.documentElement.style.overflow = 'hidden';
		document.body.style.overflow = 'hidden';
		if (scrollbarCompensation > 0) {
			document.body.style.paddingRight = scrollbarCompensation + 'px';
		}
		if (typeof window.evonaLenis !== 'undefined' && window.evonaLenis && typeof window.evonaLenis.stop === 'function') {
			window.evonaLenis.stop();
		}
		document.addEventListener('touchmove', preventScrollOutside, { passive: false });
	}

	function unlockScroll() {
		document.removeEventListener('touchmove', preventScrollOutside);
		document.documentElement.style.overflow = '';
		document.body.style.overflow = '';
		document.body.style.paddingRight = '';
		scrollbarCompensation = 0;
		if (typeof window.evonaLenis !== 'undefined' && window.evonaLenis && typeof window.evonaLenis.start === 'function') {
			window.evonaLenis.start();
		}
	}

	function preventScrollOutside(e) {
		var content = modal.querySelector('.hero-video-popup__content');
		if (content && content.contains(e.target)) {
			return;
		}
		e.preventDefault();
	}

	function openHeroVideo(triggerEl) {
		var src = triggerEl && triggerEl.getAttribute('data-hero-video-src');
		if (!src || !video) {
			return;
		}
		lastTrigger = triggerEl.nodeType === 1 ? triggerEl : null;
		video.src = src;
		video.load();
		if (videoWrap) {
			videoWrap.classList.remove('is-playing');
		}
		modal.classList.add('is-open');
		modal.setAttribute('aria-hidden', 'false');
		lockScroll();
		var closeBtn = modal.querySelector('.hero-video-popup__close');
		if (closeBtn && closeBtn.focus) {
			setTimeout(function() {
				try {
					closeBtn.focus();
				} catch (err) {}
			}, 50);
		}
		function tryPlay() {
			video.play().catch(function() {});
		}
		if (video.readyState >= 2) {
			tryPlay();
		} else {
			video.addEventListener('canplay', tryPlay, { once: true });
		}
	}

	if (video) {
		video.addEventListener('play', function() {
			if (videoWrap) {
				videoWrap.classList.add('is-playing');
			}
		});
	}

	function closeHeroVideo() {
		if (!modal.classList.contains('is-open')) {
			return;
		}
		modal.classList.remove('is-open');
		modal.setAttribute('aria-hidden', 'true');
		if (video) {
			video.pause();
			video.removeAttribute('src');
			video.load();
		}
		if (videoWrap) {
			videoWrap.classList.remove('is-playing');
		}
		unlockScroll();
		if (lastTrigger && document.body.contains(lastTrigger)) {
			try {
				lastTrigger.focus({ preventScroll: true });
			} catch (err) {}
		}
		lastTrigger = null;
	}

	document.addEventListener('click', function(e) {
		var trigger = e.target.closest('[data-hero-video-popup]');
		if (trigger) {
			e.preventDefault();
			openHeroVideo(trigger);
		}
	});

	modal.addEventListener('click', function(e) {
		if (e.target.closest('[data-hero-video-popup-close]')) {
			e.preventDefault();
			closeHeroVideo();
		}
	});

	document.addEventListener('keydown', function(e) {
		if (e.key !== 'Escape') {
			return;
		}
		if (modal.classList.contains('is-open')) {
			closeHeroVideo();
			e.preventDefault();
		}
	});
})();
